"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariablesConfigParser = void 0;
/**
 * Parser for VariablesConfig.md file
 * Loads user variables and mandatory variables from the configuration file
 */
class VariablesConfigParser {
    /**
     * Parse VariablesConfig.md content
     */
    static parse(configContent) {
        const lines = configContent.split('\n');
        const config = {
            userVariables: [],
            mandatoryVariables: {
                player: [],
                character: []
            }
        };
        let currentSection = '';
        let currentSubsection = '';
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i].trim();
            // Skip empty lines but process comments and headers
            if (!line) {
                continue;
            }
            // Check for section headers
            if (line.startsWith('## ')) {
                currentSection = line.substring(3).toLowerCase().trim();
                currentSubsection = '';
                continue;
            }
            // Check for subsection headers
            if (line.startsWith('### ')) {
                currentSubsection = line.substring(4).toLowerCase().trim();
                continue;
            }
            // Skip comment lines (but not headers)
            if (line.startsWith('#') && !line.startsWith('##')) {
                continue;
            }
            // Check for Variables: keyword
            if (line === 'Variables:') {
                // Parse variables until we hit another section or end of file
                const variables = this.parseVariablesBlock(lines, i + 1, currentSection, currentSubsection);
                if (currentSection === 'user variables') {
                    config.userVariables = variables;
                }
                else if (currentSection === 'mandatory variables') {
                    if (currentSubsection === 'player variables') {
                        config.mandatoryVariables.player = variables;
                    }
                    else if (currentSubsection === 'character variables') {
                        config.mandatoryVariables.character = variables;
                    }
                }
                // Skip the parsed variables
                i += variables.length;
                continue;
            }
        }
        return config;
    }
    /**
     * Parse a Variables block
     */
    static parseVariablesBlock(lines, startIndex, currentSection, currentSubsection) {
        const variables = [];
        for (let i = startIndex; i < lines.length; i++) {
            const line = lines[i].trim();
            // Stop at empty lines or section headers
            if (!line || line.startsWith('#')) {
                break;
            }
            // Skip non-variable lines
            if (!line.includes(':')) {
                continue;
            }
            const variable = this.parseVariableDeclaration(line, currentSection, currentSubsection);
            if (variable) {
                variables.push(variable);
            }
        }
        return variables;
    }
    /**
     * Parse a single variable declaration
     */
    static parseVariableDeclaration(line, currentSection, currentSubsection) {
        try {
            // Pattern: type name: "description" = value
            const match = line.match(/^\s*(\w+)\s+(\w+):\s*"([^"]*)"\s*=\s*(.+)$/);
            if (!match) {
                console.warn(`Invalid variable declaration format: ${line}`);
                return null;
            }
            const [, type, name, description, defaultValueStr] = match;
            // Validate type
            if (!['string', 'number', 'boolean', 'stack'].includes(type)) {
                console.warn(`Invalid variable type: ${type}. Must be string, number, boolean, or stack`);
                return null;
            }
            // Validate name format
            if (!/^[a-z][a-z0-9_]*$/.test(name)) {
                console.warn(`Invalid variable name format: ${name}. Must start with lowercase letter and contain only lowercase letters, numbers, and underscores`);
                return null;
            }
            // Parse default value based on type
            let defaultValue;
            switch (type) {
                case 'string':
                    // Remove surrounding quotes if present
                    let stringValue = defaultValueStr.trim();
                    if (stringValue.startsWith('"') && stringValue.endsWith('"')) {
                        stringValue = stringValue.slice(1, -1);
                    }
                    defaultValue = stringValue;
                    break;
                case 'number':
                    const numValue = parseFloat(defaultValueStr.trim());
                    if (isNaN(numValue)) {
                        console.warn(`Invalid number value: ${defaultValueStr}`);
                        return null;
                    }
                    defaultValue = numValue;
                    break;
                case 'boolean':
                    const boolValue = defaultValueStr.trim().toLowerCase();
                    if (boolValue === 'true') {
                        defaultValue = true;
                    }
                    else if (boolValue === 'false') {
                        defaultValue = false;
                    }
                    else {
                        console.warn(`Invalid boolean value: ${defaultValueStr}. Must be true or false`);
                        return null;
                    }
                    break;
                case 'stack':
                    // Stack type: default value should be JSON array string or empty array
                    let stackValue = defaultValueStr.trim();
                    if (stackValue === '' || stackValue === '[]') {
                        defaultValue = '[]';
                    }
                    else if (stackValue.startsWith('[') && stackValue.endsWith(']')) {
                        // Already a JSON array string
                        defaultValue = stackValue;
                    }
                    else {
                        // If it's quoted, remove quotes
                        if (stackValue.startsWith('"') && stackValue.endsWith('"')) {
                            stackValue = stackValue.slice(1, -1);
                        }
                        // Validate it's a JSON array
                        try {
                            const parsed = JSON.parse(stackValue);
                            if (!Array.isArray(parsed)) {
                                console.warn(`Stack default value must be a JSON array: ${stackValue}`);
                                return null;
                            }
                            defaultValue = stackValue;
                        }
                        catch (e) {
                            // If not valid JSON, default to empty array
                            defaultValue = '[]';
                        }
                    }
                    break;
                default:
                    console.warn(`Unsupported type: ${type}`);
                    return null;
            }
            // Determine owner scope based on context
            let ownerScope = 'adventure'; // default
            if (name.startsWith('user_')) {
                ownerScope = 'user';
            }
            else if (currentSection === 'mandatory variables') {
                if (currentSubsection === 'player variables') {
                    ownerScope = 'player';
                }
                else if (currentSubsection === 'character variables') {
                    ownerScope = 'character';
                }
            }
            return {
                name,
                type: type,
                description,
                defaultValue,
                ownerScope
            };
        }
        catch (error) {
            console.warn(`Error parsing variable declaration: ${line}`, error);
            return null;
        }
    }
    /**
     * Load VariablesConfig from file system (for Node.js environments)
     */
    static async loadFromFile(filePath) {
        try {
            const fs = await Promise.resolve().then(() => __importStar(require('fs/promises')));
            const content = await fs.readFile(filePath, 'utf-8');
            return this.parse(content);
        }
        catch (error) {
            console.error(`Failed to load VariablesConfig from ${filePath}:`, error);
            // Return empty config as fallback
            return {
                userVariables: [],
                mandatoryVariables: {
                    player: [],
                    character: []
                }
            };
        }
    }
    /**
     * Load VariablesConfig from string content
     */
    static loadFromString(content) {
        return this.parse(content);
    }
}
exports.VariablesConfigParser = VariablesConfigParser;
//# sourceMappingURL=VariablesConfigParser.js.map